import { useEffect } from "react";
import { tokenManager } from "lib/tokenManager";

export const Logout = () => {
    useEffect(() => {
        tokenManager.set(null);
        localStorage.removeItem("token");
        window.location.href = "/login";
    }, []);

    return null;
};
